import {ChangeLangService} from "./lang/changeLang.service";

const sortBy = require('lodash/sortBy');
const map = require('lodash/map');
const escapeRegExp = require('lodash/escapeRegExp');
//const XRegExp = require('xregexp');
const partition = require('lodash/partition');
const memoize = require('lodash/memoize');
const MAX_CACHE_SIZE = 50;
import {isBrowserChrome} from './browserSniffer';
import {Injectable} from 'ng-metadata/core';

@Injectable()
export class HighlightService {

    constructor(private changeLangService: ChangeLangService) {
    }

    // Highlighted regular expresion
    private memoizedFun = memoize((terms) => this._getTermRegexp(terms), (terms) => terms ? terms.join("##$&") : '');
    private memoizedFunCache = this.memoizedFun.cache;
    private combiningHalfMarksRegexp = new RegExp('(.[\uFE20-\uFE2F].[\uFE20-\uFE2F])', 'gi');
    private combiningDiacriticalMarksRegexp = new RegExp('(.[\u0361].)', 'gi');

    public getTermRegexp(terms) {
        if (this.memoizedFunCache.size > MAX_CACHE_SIZE) {
            this.memoizedFunCache.clear();
        }
        return this.memoizedFun(terms);
    }

    private _getTermRegexp(terms) {
        let finalRegs = [];
        if (!terms || terms.length==0) return null;
        let l_anchor = '(?:^|$|' + '[ \\n\\r\\t.,`@)(%~><}{\\[\\]\\\\\\/—“:;_&^#$%\'\\\"\\\+!?*=#|-]' + ')';
        let r_anchor = '(?=^|$|' + '[ \\n\\r\\t.,`@)(%~><}{\\[\\]\\\\\\/—”:;_&^#$%\'\\\"\\\+!?*=#|-]' + ')';
        let sortedTerms = sortBy(terms, (e) => -e.length);
        let escapedTerms = map(sortedTerms, escapeRegExp);
        let partitionedCjk = partition(escapedTerms, (e) => this.isCJK(e));
        if (partitionedCjk[0].length) {
            finalRegs.push('(' + partitionedCjk[0].join('|') + ')');

        }
        if (partitionedCjk[1].length) {
            let nonCjkRegs = map(partitionedCjk[1], (e) => e.trim().split(' ').join(' *?')).join("|");
            let noncjkTerm = `(?:${l_anchor}(${nonCjkRegs})${r_anchor})`;
            finalRegs.push(noncjkTerm);
        }


        let finalTerm = finalRegs.join('|');

        return new RegExp(finalTerm, 'gi');
    }

    private checkWithBoundaries(match, match1, match2) {
        let anchor = /[ \n\r\t.,`@)(%~><}{\[\]\\\/:;_&^#$%'\"\+!?*=#|-]/;
        let replaceText = match1 || match2;
        if (match.charAt(0).match(anchor)) {
            return match[0] + `<mark>${replaceText}</mark>`;
        } else {
            return `<mark>${match}</mark>`;
        }
    }


    public getHighlightedText(text, regexp) {
        let highlighted = '';
        if (!text) {
            return '';
        }

        if (text.indexOf('<') !== -1) {
            if (!this.containsValidHTML(text)) {
                text = text.replace(/</g, '&lt;');
                text = text.replace(/>/g, '&gt;');
            }
            else if (this.containsMarkTag(text)) {
                return text;
            }
        }

        if (regexp) {
	        highlighted = text.replace(/(<[^>]+>)|([^<]+)/g, (match, tag, textContent) => {
	            if (tag) {
                    if (/^<\/?title.*>$/.test(tag)) {
                        return '';
                    }
                    return tag;
	            } else if (textContent) {
	                // Apply highlighting to text outside HTML tags
	                return this.replaceWithMark(textContent, regexp);
	            }
	            return match;
	        });
        } else {
            highlighted = text;
        }


        /* Hack for PRM-32834 New UI in IE: Combining Diacritical Marks are displayed incorrectly due to font type
            Since using font-face for this range does not work
        */
        if (!isBrowserChrome()) {
            if (this.isCombiningHalfMarks(highlighted)) {
                highlighted = this.replaceCombiningHalfMarks(highlighted);
            }
        }

        if (this.isCombiningDiacriticalMark(highlighted)) {
            highlighted = this.replaceCombiningDiacriticalMark(highlighted);
        }

        return highlighted;
    }

	private replaceWithMark(text, regexp){
		// If the tag has no attributes, apply the highlighting
		if (this.isCJK(text)) {
			return text.replace(regexp, (match) => `<mark>${match}</mark>`).replace(/<\/mark> <mark>/g, ' ');
		}else{
		  	return text.replace(regexp, this.checkWithBoundaries).replace(/<\/mark> <mark>/g, ' ');
		}		
	}
	
    private replaceCombiningHalfMarks(text) {
        text = text.replace(this.combiningHalfMarksRegexp, (match) => `<span class="combined-half-mark">${match}</span>`);
        return text;
    }

    private replaceCombiningDiacriticalMark(text) {
        text = text.replace(this.combiningDiacriticalMarksRegexp, (match) => `<span class="combined-half-mark">${match}</span>`);
        return text;
    }

    private isCombiningHalfMarks(text) {
        let combiningHalfMarksRegexp = /[\uFE20-\uFE2F]/;
        return combiningHalfMarksRegexp.test(text);
    }

    private isCombiningDiacriticalMark(text) {
        let combiningDiacriticalMarkRegexp = /[\u0361]/;
        return combiningDiacriticalMarkRegexp.test(text);
    }

    private isCJK(text) {
        let cregexp = /[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]/;
        let jregexp = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;
        let kogexp = /[\uAC00-\uD7A3\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uD7B0-\uD7FF]/;
        let vietexp = /[\u02C6-\u0323]/;

        return cregexp.test(text) || jregexp.test(text) || kogexp.test(text) || vietexp.test(text);
    }


    private determineDirection(text) {
        // Regular expressions for RTL (Hebrew/Arabic) and LTR (Latin) text blocks
        const rtlRegex = /[\u0590-\u05FF\u0600-\u06FF]+/; // Hebrew (0590-05FF), Arabic (0600-06FF)

        const neutralRegex = /[\d\s\(\)\[\]\.,:;!?]+/; // Punctuation, digits, and neutral characters
        for (let char of text) {
            if (rtlRegex.test(char)) return 'rtl';
            if (!neutralRegex.test(char)) return 'ltr';
        }
        return null;
    };

    public bidirectionalText(strArray) {
        const rtlLang = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
        const ltrLang = /[A-Za-zÀ-ÖØ-öø-ÿĀ-ž]/;
        const ltrAndDigitsAndPunctuation = /^[A-Za-zÀ-ÖØ-öø-ÿĀ-ž0-9\s.,`@)(%~><}{\[\]\\\/:;_&^#$%'\"+!?*=#|-]+$/;
        const rtlAndDigitsAndPunctuation = /^[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC0-9\s.,`@)(%~><}{\[\]\\\/:;_&^#$%'\"+!?*=#|-]+$/;
        const bidiChars = /[\u202A-\u202B\u202C-\u202E\u2066-\u2069\u200E-\u200F\u061C-\u061C]/g;
        const dirDefinedInData = /.*dir.*=.*[\"|\'](ltr|rtl|auto)[\"|\'].*/;
        const rtlChars = /[\u200F]/g;
        const ltrChars = /[\u200E]/g;
        const UniversalPunctuationMark = /[.,`@)(%~><}{\[\]\\\/:;_&^#$%'\"\+!?*=#|-]/;
        const spacers = /[ \t]/;
        const digits = /[0-9]/;
        let resEmpty = {fixedStr: strArray, isBidi: false};
        //return resEmpty;
        if (bidiChars.test(strArray) || dirDefinedInData.test(strArray)) {
            return resEmpty;
        }

        //if we are in ltr and no rtl characters - no need to do anything
        if (!rtlLang.test(strArray) && this.changeLangService.direction === 'ltr') {
            return resEmpty;
        }

        if (rtlLang.test(strArray) && !ltrLang.test(strArray)) {
            return resEmpty;
        }

        if (ltrLang.test(strArray) && !rtlLang.test(strArray)) {
            return resEmpty;
        }

        if (ltrAndDigitsAndPunctuation.test(strArray) && !rtlAndDigitsAndPunctuation.test(strArray)) {
            return resEmpty;
        }

        if (!ltrAndDigitsAndPunctuation.test(strArray) && rtlAndDigitsAndPunctuation.test(strArray)) {
            return resEmpty;
        }

        strArray = strArray || '';

        if (this.containsValidHTML(strArray)) {
            return resEmpty
        }


        const blocks = strArray.split(/(\s+)/).filter(block => block !== '');
        // Blocks list
        let mergedBlocks = [];
        let currentBlock: { block: any; direction: string } = {block: '', direction: null};

        blocks.forEach(block => {
            const direction = this.determineDirection(block);
            if (direction && currentBlock.direction !== direction) {
                if (currentBlock.block) mergedBlocks.push(currentBlock);
                currentBlock = {block, direction};
            } else {
                currentBlock.block += block;
                currentBlock.direction = direction || currentBlock.direction;
            }
        });

        if (currentBlock.block) mergedBlocks.push(currentBlock);

        //an array of { block, direction }

        // Merged blocks
        let result = mergedBlocks;
        let strongIndication = 'ltr';
        if (result.length > 1) {
            strongIndication = result[0].direction;
            result[0].htmlWithDirection = `<span dir='${strongIndication}'>${result[0].block}`;
            for (let i = 1; i < result.length; i++) {
                if (result[i].direction !== strongIndication) {
                    if (result[i].block.lastIndexOf(' ') == result[i].block.length - 1 && i < result.length - 1) {
                        result[i].block = result[i].block.substring(0, result[i].block.length - 1);
                        result[i + 1].block = ' ' + result[i + 1].block;
                    }
                    result[i].htmlWithDirection = `&nbsp;<span dir='${result[i].direction}'>${result[i].block}</span>`;
                } else {
                    result[i].htmlWithDirection = result[i].block;
                }
            }
            result[result.length - 1].htmlWithDirection += '</span>';

        }

        // Result
        let resultString = result.map(obj => obj.htmlWithDirection)  // Extract 'htmlWithDirection' property
            .filter(html => html !== undefined && html !== null)  // Remove undefined or null values
            .join('');

        if (resultString.length === 0) {
            return resEmpty;
        }

        let isBidi = false;
        if (rtlChars.test(resultString) && ltrChars.test(resultString)) {
            isBidi = true;
        }

        return {fixedStr: resultString, isBidi: isBidi};
    }



    /*
    * returns true if a text contains a valid HTML element
    */
    public containsValidHTML(text) {
        let htmlTags = /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|IMG|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/g;
        let containsValidHTML = htmlTags.exec(text.replace(/\r?\n|\r/gm, ''));
        return containsValidHTML != null ? containsValidHTML.length > 0 : false;
    }


    /*
    * returns true if a text contains a valid HTML element
    */
    public containsMarkTag(text) {
        let htmlTags = /<(mark).*?<\/\2>/g;
        let containsValidHTML =  htmlTags.exec(text.replace(/\r?\n|\r/gm, ''));
        return containsValidHTML != null ? containsValidHTML.length > 0 : false;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/highlight.service.ts